import { render, staticRenderFns } from "./StudyProgramSelector.vue?vue&type=template&id=3ca2b6c5&scoped=true&"
import script from "./StudyProgramSelector.vue?vue&type=script&lang=js&"
export * from "./StudyProgramSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca2b6c5",
  null
  
)

export default component.exports